import {gql, useQuery} from '@apollo/client'
import { ALL_PICTURE_FIELDS } from 'graphql/APICalls'
import { useMemo } from 'react'

import 'styles/Team.css';
import 'styles/UserProfile.css';

export default function Team() {

  const GET_USER = gql`
    query GetUser($username: String!) {
      getUser(username: $username) { name, picture ${ALL_PICTURE_FIELDS}, bio }
    }
  `

  const {data, loading, error} = useQuery(GET_USER, {variables: {username: "george"}})
  const user = useMemo(() => data?.getUser, [data])

  return (
    <div className="centerer team-overlay">
      <div className="centered team-container">
        <h2>Team</h2>
        <div className="profile-user-card">
            <div className="profile-image own">
                <img alt="user profile pic" src={user?.picture?.imageSrc}/>
            </div>
            <div className="profile-user-data">
              <label className="profile-field-value"><b>{user?.name}</b></label>
              <label className="profile-field-value">{user?.bio}</label>
            </div>
        </div>
      </div>
    </div>
  )
}